<template>
  <p>Signing in...</p>
</template>
<script>
export default {
  async mounted() {
  }
};
</script>
